import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { handleUserLevelAccessPermissions, validateRolesIIPHQ } from "../../../../Custom/Custom";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { generateExcelASITable3 } from "../../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportExcel";
import messages from '../../../../assets/Messages.json';
import asiTitle from '../../../../asi.json';

const Table3Report = () => {
    const [year,setYear]=useState([]); 
    const [yearName, setYearName] = useState("");
    const [tableReportData, setTableReportData] = useState([]);
    const [buttonAccess, setButtonAccess] = useState({
        userLevel: "",
        roles: "",
        isVisible: false,
    });

    const token = useContext(MyContextProvider).token;
    const decode_token = jwtDecode(token);
    const navigate = useNavigate();
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };


    const storedLanguage = localStorage.getItem('language');

    const getSurveyYears=async()=>{
        showLoading(true)
           try {
              const response = await axios.get(`${API_URL}api/asi/surveyYearList`, config);
              const allYear = response.data;
              if (allYear.status) {
                  setYear(allYear.data.surveyYearList.reverse())
                  showLoading(false);
              }
        } catch (error) {
           console.error(error);
           showLoading(false);
        }finally{
           showLoading(false);
        }
      
      }


    useEffect(() => {
        const level = handleUserLevelAccessPermissions(decode_token);
        setButtonAccess(level);
        getSurveyYears()
      }, []);



      const handleDropdownChange = (e) => {
        setYearName(e.target.value);
      };

      const downloadStaticTable3Xlsx = async () => {
        const fileUrl = `pdf/ASI_Table3.xlsx`;
        try {
          const response = await fetch(fileUrl);
          if (!response.ok) {
            throw new Error("File not found");
          }
          const blob = await response.blob();
          const objectUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = objectUrl;
          link.download = "ASI_Table3.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(objectUrl);
        } catch (error) {
          console.error(error);
          toast.error("File not found", messages.COLOR_RED);
        } finally {
          showLoading(false);
        }
      };
    const handleGenerateExcel = () => {
        if (!yearName) {
          toast.error("Please select a Survey Year", messages.COLOR_RED);
          return;
        }
    
        showLoading(true);

        const payload = {
          survey_year: yearName,
        };
        if (String(yearName) === "2023") {
            downloadStaticTable3Xlsx();
            return false;
          }

        axios
            .post(`${API_URL}api/asi/reports/HQReports/asigetTable3Report`, payload, config)
            .then((response) => {
                const table3Report = response.data?.data?.asigetTable3DSLReportdata;
                const totalCounts = response.data?.data?.totalCounts;

                if (!table3Report || table3Report.length === 0) {
                    toast.error("Data not found", messages.COLOR_RED);
                    showLoading(false);
                    return;
                }

                const tabYear = parseInt(yearName, 10);
                const excelObjectData = {
                    fileName: 'ASI_Table3',
                    reportType: 'ASI_Table3',
                    fileType: 'xlsx',
                    sheetName: "ASI_Table3",
                    firstRowMergeCells: "A1:K1",
                    firstRowExportData: 'सारिणी-३',
                    firstRowCellNumber: 11,
                    secondRowMergeCells: "A2:K2",
                    secondRowText: `वार्षिक उद्योग सर्वेक्षण ${yearName}-${(tabYear + 1).toString().slice(-2)}`,
                    thirdRowMergeCells: "A3:K3",
                    thirdRowText: 'उत्तर प्रदेश के उद्योगों का रोजगार एवं परिलब्धियाँ',
                    headerHindiColumns: [],
                };

                const transformedData = table3Report.map((item) => [
                    item.NIC_CODE_PERFRAME ?? item.nicCodePerframe,
                    item.registered,
                    item.working,
                    item.estimated,
                    item.Mandaysemployed ?? item.manDays,
                    item.Workers ?? item.worker,
                    item.SupervisoryManagerialStaff ?? item.sperviser,
                    item.Otheremployees ?? item.otheremp,
                    item.AverageNoofpersonsengaged ?? item.allemp,
                    item.Workers_WAGES ?? item.kulWorker,
                    item.kulAllworker,
                ]);

                if (totalCounts) {
                    transformedData.push([
                        'TOTAL',
                        totalCounts.totalRegistered,
                        totalCounts.totalWorking,
                        totalCounts.totalEstimated,
                        totalCounts.totalmanDays,
                        totalCounts.totalworker,
                        totalCounts.totalsperviser,
                        totalCounts.totalotheremp,
                        totalCounts.totalallemp,
                        totalCounts.totalkulWorker,
                        totalCounts.totalkulAllworker,
                    ]);
                }

                excelObjectData.excelRowData = transformedData;

                generateExcelASITable3(excelObjectData);
    
                showLoading(false);
            })
            .catch((error) => {
                console.error('API Error:', error);
                showLoading(false);
            });
    };


    return (
        <>
            <GlobalLoading />
            <ToastContainer />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                            <h4 className="page_heading">
                                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.TABLE_THREE_REPORT : asiTitle.en.TABLE_THREE_REPORT }} />
                            </h4>
                            <div className="row align-items-center">
                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">
                                    {storedLanguage === 'hi' ? asiTitle.hi.SURVEY_YAER : asiTitle.en.SURVEY_YAER}
                                    </label>
                                    <select
                                        name="year_name"
                                        className="form-select"
                                        onChange={handleDropdownChange}
                                        value={yearName}
                                    >
                                        <option value="" disabled>
                                            Select Year
                                        </option>
                                        {year
                                        .sort((a, b) => b - a) 
                                        .map((yearName, index) => (
                                            <option key={index} value={yearName}>
                                            {yearName}-{(parseInt(yearName) + 1).toString().slice(2)}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                                <div className="col-xl-2 col-lg-12 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Table3Report